import { styled } from 'styled-components';
import ImageWrapper from '../../../new-components/ImageWrapper';
import BannerBackground from '../../../public/assets/images/banners/compound-banner-bg.png';
import BannerBackgroundAr from '../../../public/assets/images/banners/compound-banner-bg-ar.png';
import BannerImg from '../../../public/assets/images/banners/compound-banner.png';
import BannerImgAr from '../../../public/assets/images/banners/compound-banner-ar.png';
import BannerImgMobile from '../../../public/assets/images/banners/compound-banner-mobile.png';
import LineArrow from '../../../public/assets/icons/common/LineArrow';
import { useContext } from 'react';
import {
  SearchContext,
  SearchContextInterface
} from '../../search-new/context/SearchContext';
import { SearchFiltersActionTypes } from '../../../reducers/search-filters/actions';
import { SearchFiltersTypes } from '../../../reducers/search-filters/reducer';
import { scrollToComponent } from '../../../helpers/common';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';

const CompoundNawyNowBanner = () => {
  const { t } = useTranslation('entity');
  const { locale } = useRouter();
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const { searchFiltersDispatch } = useContext(
    SearchContext
  ) as SearchContextInterface;
  const handleClick = () => {
    searchFiltersDispatch({
      type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
      payload: {
        name: SearchFiltersTypes.SALE_TYPE,
        value: []
      }
    });
    searchFiltersDispatch({
      type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
      payload: {
        name: SearchFiltersTypes.NAWY_NOW,
        value: true
      }
    });

    const offset = isMobile ? 200 : 300;

    scrollToComponent('sale-type-tabs', offset, 'smooth');
  };
  return (
    <Container locale={locale}>
      <div className="banner-content">
        <span className="banner-title">{t('move_now_pay_later')}</span>
        {isMobile ? (
          <span className="banner-subtitle">{t('find_ready_home_mobile')}</span>
        ) : (
          <>
            <span className="banner-subtitle">{t('find_ready_home')}</span>
            <span className="banner-subtitle">
              {t('find_ready_home_second')}
            </span>
          </>
        )}
        <div className="banner-btn-container">
          <button onClick={handleClick} className="banner-btn">
            {t('explore')}
          </button>
          <LineArrow />
        </div>
      </div>
      <ImageWrapper
        fill={false}
        src={
          isMobile ? BannerImgMobile : locale == 'en' ? BannerImg : BannerImgAr
        }
        alt={'compound nawy now banner'}
        className="banner-img"
      />
      {!isMobile && (
        <ImageWrapper
          fill={true}
          src={locale == 'en' ? BannerBackground : BannerBackgroundAr}
          alt={'compound nawy now banner background'}
          objectFit="cover"
          className="banner-bg"
        />
      )}
    </Container>
  );
};

const Container = styled.div<any>`
  width: 100%;
  height: 182px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px;
  border-radius: 12px;
  /* background: linear-gradient(299deg, #ffd6bf 1.99%, #fff0e8 71.08%); */
  margin: 64px 0px !important;

  .banner-content {
    display: flex;
    flex-direction: column;

    .banner-title {
      color: #2c3138;
      font-family: materialBold;
      font-size: 28px;
      text-transform: uppercase;
      margin-bottom: 2px;
    }

    .banner-subtitle {
      color: #212427;
      font-family: materialRegular;
      font-size: 18px;
      text-transform: capitalize;
      margin-top: 2px;
    }

    .banner-btn-container {
      display: flex;
      align-items: self-end;
      .banner-btn {
        margin-top: 24px;
        background-color: transparent;
        border: 0px solid transparent;
        color: #ff5e00;
        /* width: 100px; */
        text-align: center;
        font-family: materialMedium;
        font-size: 20px;
        text-transform: capitalize;
      }

      svg {
        margin: 0px 6px;
      }
    }
  }

  .banner-img {
    position: absolute;
    bottom: -150px;
    ${props => (props.locale == 'en' ? 'right: -10%' : 'left: -10%')};
    transform: scale(0.5);
  }

  .banner-bg {
    width: 100%;
    height: 100%;
    z-index: -1;
    border-radius: 12px;
  }

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    padding: 10px 12px;
    height: 114px;
    margin: 32px auto 0px !important;
    background: linear-gradient(299deg, #ffd6bf 1.99%, #fff0e8 71.08%);
    width: calc(100% - 24px);

    .banner-content {
      justify-content: space-between;
      gap: 4px;
      .banner-title {
        color: #2c3138;
        font-family: materialBold;
        font-size: 18px;
        text-transform: uppercase;
        margin-bottom: 4px;
      }

      .banner-subtitle {
        color: #212427;
        font-family: materialRegular;
        width: 60%;
        font-size: 12px;
        text-transform: capitalize;
      }

      .banner-btn-container {
        gap: 4px;

        .banner-btn {
          margin-top: 0px;
          color: #ff5e00;
          text-align: center;
          font-family: materialMedium;
          font-size: 14px;
          text-transform: capitalize;
          width: unset;
        }

        svg {
          width: 18px;
          height: 18px;
        }
      }
    }

    .banner-img {
      bottom: -75px;
      ${props => (props.locale == 'en' ? 'right: -24%' : 'left: -24%')};
    }
  }
`;

export default CompoundNawyNowBanner;
